import { useTranslation } from 'react-i18next'

import { useCreateDispatch } from '#/shared/api/generated/loadboard/theCargoLoadboard'
import type { CreateDispatchRequest } from '#/shared/api/generated/loadboard/models'
import { getApiErrorDetail } from '#/shared/lib/api/error-handler'
import { toast } from '#/shared/ui/sonner'

interface UseDispatchCarrierParams {
  shipmentId: string
  onSuccess?: () => void
}

interface DispatchSubmitArgs {
  carrierId: string
  listingId?: string
}

export function useDispatchCarrier({
  shipmentId,
  onSuccess,
}: UseDispatchCarrierParams) {
  const { t } = useTranslation()
  const mutation = useCreateDispatch()

  const submit = async ({
    carrierId,
    listingId,
  }: DispatchSubmitArgs): Promise<boolean> => {
    const toastId = toast.loading(t('orderDispatch.toast.dispatching'))
    try {
      const data: CreateDispatchRequest = {
        listingId: listingId ?? null,
        carrierId,
        shipmentId,
      } as CreateDispatchRequest
      await mutation.mutateAsync({ data })
      toast.success(t('orderDispatch.toast.success'), { id: toastId })
      onSuccess?.()
      return true
    } catch (error) {
      toast.error(getApiErrorDetail(error) ?? t('orderDispatch.toast.error'), {
        id: toastId,
      })
      return false
    }
  }

  return {
    submit,
    isSubmitting: mutation.isPending,
  }
}
